import { createStyles, makeStyles } from '@material-ui/core/styles';

const useScoreStyles = makeStyles(() =>
  createStyles({
    scoreText: {
      margin: '0.25rem 0',
      color: '#2864ac'
    },
    textPadding: {
      padding: '0 0.5rem'
    }
  })
);

export default useScoreStyles;
